// ============================================
// EDIT YOUR WEBSITE CONTENT HERE
// ============================================

const content = {
  name: "Ishan Baliyan",
  
  intro: "Software Engineer at xAI. Waterloo.",
  
  bio: `I like hacking on ideas and seeing what sticks. Some of my side projects have reached 50,000+ downloads and ~$30k in revenue — including a job-search app.`,
  
  appLink: {
    text: "job-search app.",
    url: "https://apps.apple.com/us/app/resume-builder-ai-cv-maker/id6463698204"
  },

  resumeText: "Resume →",
  resumeFile: "/assets/resume.pdf",

  // Optional: Add social links (leave empty {} to hide)
  socials: {
    // github: "https://github.com/IshanBaliyan",
    // twitter: "https://twitter.com/yourusername",
    // linkedin: "https://linkedin.com/in/ishanbaliyan",
  }
};

export default content;

